import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LeftSidePanel from '@/components/UI/LeftSidePanel';
import { Button } from '@/components/UI/Button';

const TenantSuspendedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="auth-bg flex min-h-dvh relative overflow-hidden">
      <LeftSidePanel />

      <div className="flex-1 flex items-center justify-center px-6 py-12">
        <div className="card-surface px-10 py-10 text-center w-full max-w-md">
          <div className="w-16 h-16 rounded-full bg-warning/15 flex items-center justify-center mx-auto mb-6">
            <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8 text-warning-text" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>

          <h1 className="text-h3 text-ui-text mb-3">
            {t('suspension.tenantTitle', 'Account Suspended')}
          </h1>

          <p className="text-sm text-ui-text2 mb-2">
            {t('suspension.tenantMessage', 'Your account has been suspended from this tenant.')}
          </p>
          <p className="text-sm text-ui-text3 mb-8">
            {t('suspension.contactAdmin', 'Please contact your tenant administrator to restore access.')}
          </p>

          <Button size="lg" className="w-full"
            onClick={() => navigate('/login')}>
            {t('auth.backToLogin', 'Back to Login')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TenantSuspendedPage;
